'use client';

import type { MouseEvent, ReactNode } from 'react';
import { toggleDisclosure } from './vehicleDisclosure';

/**
 * Client boundary around server-rendered disclosures: the summary clicks are
 * picked up by delegation, so only this listener ships. Opening one collapses
 * the others, both animated. The summaries stay the real controls — Enter and
 * Space fire a click that bubbles up here.
 */
export function VehicleDisclosureGroup({ children }: { children: ReactNode }) {
    function handleClick(event: MouseEvent<HTMLDivElement>) {
        const details = (event.target as Element).closest('summary')?.parentElement;
        if (!(details instanceof HTMLDetailsElement)) return;

        event.preventDefault();
        toggleDisclosure(details, event.currentTarget);
    }

    return <div onClick={handleClick}>{children}</div>;
}
